import { array, func, number, string } from "prop-types"
import Selection from "./Selection"
import { Box, StackView, Text } from "@planningcenter/tapestry-react"
import { colors } from "components/shared/admin_colors"

const SelectionGroup = ({ onSelectionsChange, selections = [], className }) => {
  const showWaitlist = selections.some(({ waitlist }) => !!waitlist)

  const handleSelectionChange = selectionChange => {
    onSelectionsChange([selectionChange])
  }

  return (
    <Box className={className}>
      <StackView spacing={2} className="selectionList">
        {selections
          .filter(({ waitlist }) => !waitlist)
          .map(selection => (
            <Selection key={selection.id} selection={selection} onChange={handleSelectionChange} />
          ))}
      </StackView>

      {showWaitlist && (
        <Box
          padding={2}
          marginHorizontal={-2}
          backgroundColor={colors.neutral_100}
          borderRadius="0 0 3px 3px"
          className="waitlistList"
        >
          <Text size={3} weight={600} marginBottom={2} color={colors.neutral_700}>
            Waitlist
          </Text>
          <StackView axis="vertical" spacing={2}>
            {selections
              .filter(({ waitlist }) => !!waitlist)
              .map(selection => (
                <Selection
                  key={selection.id}
                  selection={selection}
                  onChange={handleSelectionChange}
                />
              ))}
          </StackView>
        </Box>
      )}
    </Box>
  )
}

SelectionGroup.propTypes = {
  onSelectionsChange: func.isRequired,
  selections: array,
  signupTimeId: number,
  className: string
}

export default SelectionGroup
